'use client';

import Link from 'next/link';
import { useSession } from 'next-auth/react';

import Icon from '../ui/Icon';

const OuraLogo = () => (
  <Icon
    icon="OURA_WORD_MARK"
    color="helsinki-blue-dark"
    height={29}
    width={93}
    variant="glyph"
  />
);

const ErrorPageNavigation = () => {
  // useSession() can be undefined when rendered outside SessionProvider (e.g. error boundary)
  const session = useSession();
  const data = session.data;
  const isBuyer = data?.roles.includes('buyer') ?? false;

  return (
    <nav className="container h-[60px] py-4 desktop:h-[80px]" role="navigation">
      <ul className="flex h-full items-center gap-10">
        <li>
          {isBuyer ? (
            <OuraLogo />
          ) : (
            <Link passHref href="/">
              <OuraLogo />
            </Link>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default ErrorPageNavigation;
